/* Hero Slider
   Autoplay + navigation dots
   -------------------------------- */

(function () {
  'use strict';

  function initHeroSlider(root) {
    if (root.dataset.heroSliderInit === 'true') return;
    root.dataset.heroSliderInit = 'true';

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-slide]')
    );

    if (!slides.length) return;

    var dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-slide-dot]')
    );

    var current = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });

    if (current === -1) current = 0;

    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    var timer = null;
    var isVisible = false;

    /* -----------------------------------------
       VIDEO
       ----------------------------------------- */

    function playVideoIn(slide) {
      var video = slide.querySelector('video');

      if (!video) return;

      video.currentTime = 0;

      var playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          /* Autoplay can be blocked. */
        });
      }
    }

    function pauseVideoIn(slide) {
      var video = slide.querySelector('video');

      if (video) {
        video.pause();
      }
    }

    /* -----------------------------------------
       UPDATE DOTS
       ----------------------------------------- */

    function updateDots() {
      dots.forEach(function (dot, index) {
        var isActive = index === current;

        dot.classList.toggle('is-active', isActive);
        dot.setAttribute(
          'aria-current',
          isActive ? 'true' : 'false'
        );
      });
    }

    /* -----------------------------------------
       GO TO SLIDE
       ----------------------------------------- */

    function goToSlide(index) {
      if (index === current || !slides[index]) return;

      var previousSlide = slides[current];
      var nextSlide = slides[index];

      previousSlide.classList.remove('is-active');
      previousSlide.setAttribute('aria-hidden', 'true');
      pauseVideoIn(previousSlide);

      nextSlide.classList.add('is-active');
      nextSlide.setAttribute('aria-hidden', 'false');
      playVideoIn(nextSlide);

      current = index;

      updateDots();
    }

    /* -----------------------------------------
       NEXT SLIDE
       ----------------------------------------- */

    function goToNext() {
      var next = (current + 1) % slides.length;

      goToSlide(next);
    }

    /* -----------------------------------------
       AUTOPLAY
       ----------------------------------------- */

    function start() {
      if (
        timer ||
        reduceMotion ||
        !isVisible ||
        slides.length < 2
      ) {
        return;
      }

      timer = window.setInterval(goToNext, speed);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function restartTimer() {
      stop();
      start();
    }

    /* -----------------------------------------
       INITIAL VIDEO STATE
       ----------------------------------------- */

    slides.forEach(function (slide) {
      if (!slide.classList.contains('is-active')) {
        pauseVideoIn(slide);
      }
    });

    /* -----------------------------------------
       INITIAL DOT STATE
       ----------------------------------------- */

    updateDots();

    /* -----------------------------------------
       DOT CLICK
       ----------------------------------------- */

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(
          dot.getAttribute('data-slide-dot'),
          10
        );

        if (isNaN(index)) return;

        goToSlide(index);

        /* Restart the full autoplay interval */
        restartTimer();
      });
    });

    /* -----------------------------------------
       TAB VISIBILITY
       ----------------------------------------- */

    document.addEventListener(
      'visibilitychange',
      function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      }
    );

    /* -----------------------------------------
       INTERSECTION OBSERVER
       ----------------------------------------- */

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            isVisible = entry.isIntersecting;

            if (isVisible) {
              start();
            } else {
              stop();
            }
          });
        },
        {
          threshold: 0.25
        }
      );

      observer.observe(root);
    } else {
      isVisible = true;
      start();
    }
  }

  /* -----------------------------------------
     INITIALIZE ALL HERO SLIDERS
     ----------------------------------------- */

  function initAll() {
    document
      .querySelectorAll('[data-hero-slider]')
      .forEach(initHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }

  /* -----------------------------------------
     SHOPIFY THEME EDITOR
     ----------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      var root = event.target.querySelector(
        '[data-hero-slider]'
      );

      if (root) {
        initHeroSlider(root);
      }
    }
  );
})();